import React from  'react'
import { ErrorMessage  } from 'formik'

export const FormError = (props) => {    
  return (   
      <ErrorMessage name={props.name} render={msg => <span className="required">{msg}</span>}/>              
  )
}
